import React, { useState } from "react";
import { useNavigate } from "react-router-dom";
import { useTranslation } from "react-i18next";
import BulkProductsHeader from "../../components/Products/BulkProductsHeader";
import IntroBulk from "./IntroBulk";
import UploadBulk from "./UploadBulk";
import PreviewBulk from "./PreviewBulk";
import SuccessUpload from "./SuccessUpload";
import { API_URL } from "../../utils/config";
import { ToastContainer, toast } from "react-toastify";

const baseUrl = API_URL;
const BulkProducts = () => {
  const { t } = useTranslation("bulkproducts");
  const [currentStep, setCurrentStep] = useState(1);
  const [selectedFile, setSelectedFile] = useState(null);
  const [ImagesZipFolder, setImagesZipFolder] = useState(null);
  const [selectedSupplier, setSelectedSupplier] = useState("");
  const [isUpdatedFile, setIsUpdatedFile] = useState(false);
  const [errors, setErrors] = useState([]);
  const lang = localStorage.getItem("language") || "en";
  const navigate = useNavigate();
  const handleNext = () => {
    if (currentStep < 4) {
      setCurrentStep(currentStep + 1);
    }
  };

  const handleCancel = () => {
    // Reset to first step or navigate away
    setCurrentStep(1);
    setSelectedFile(null);
    setImagesZipFolder(null);
    setSelectedSupplier("");
    setErrors([]);
    setIsUpdatedFile(false);
  };
  const handleBack = () => {
    setCurrentStep(currentStep - 1);
    setSelectedFile(null);
    setSelectedSupplier("");
    setErrors([]);
    setIsUpdatedFile(false);
    setImagesZipFolder(null);
  };
  const handleBackToList = () => {
    // Navigate to products list or reset
    navigate("/products");
  };

  const createBulkProducts = async (updatedFile) => {
    try {
      const formData = new FormData();
      const fileToUpload = isUpdatedFile ? updatedFile : selectedFile;
      if (!fileToUpload) {
        toast.error(t("upload.noFileSelected"));
        throw new Error(t("upload.noFileSelected"));
      }
      if (!selectedSupplier) {
        toast.error(t("upload.noSupplierSelected"));
        throw new Error(t("upload.noSupplierSelected"));
      }
      console.log("Uploading file:", isUpdatedFile);
      formData.append("excel_file", fileToUpload);
      formData.append("images_zip", ImagesZipFolder);
      formData.append("supplier_id", selectedSupplier);

      const response = await fetch(
        `${baseUrl}/api/v1/attnd-supplier/services/bulk-create`,
        {
          credentials: "include",
          method: "POST",
          headers: {
            lang: lang,
          },
          body: formData,
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        // handle  array of errors
        if (errorData.errors && Array.isArray(errorData.errors)) {
          // set the errors to state with row number and errors array
          setErrors(
            errorData.errors.map((err) => ({
              row: err.row,
              sku: err.sku,
              errors: [err.error],
            }))
          );
          // toast.error(`Errors in file:\n${errorList}`, { autoClose: false });
        } else {
          toast.error(errorData.error || t("error.bulkCreateFailed"));
        }
        throw new Error(t("error.bulkCreateFailed"));
      }
      const result = await response.json();
      return result;
    } catch (error) {
      console.error("Error creating bulk products:", error);
      throw error;
    }
  };

  const renderCurrentStep = () => {
    switch (currentStep) {
      case 1:
        return <IntroBulk onNext={handleNext} onCancel={handleCancel} />;
      case 2:
        return (
          <UploadBulk
            onNext={handleNext}
            onCancel={handleCancel}
            selectedFile={selectedFile}
            setSelectedFile={setSelectedFile}
            ImagesZipFolder={ImagesZipFolder}
            setImagesZipFolder={setImagesZipFolder}
            selectedSupplier={selectedSupplier}
            setSelectedSupplier={setSelectedSupplier}
          />
        );
      case 3:
        return (
          <PreviewBulk
            onNext={handleNext}
            onCancel={handleCancel}
            onBack={handleBack}
            file={selectedFile}
            createBulkProducts={createBulkProducts}
            setIsUpdatedFile={setIsUpdatedFile}
            errors={errors}
          />
        );
      case 4:
        return <SuccessUpload onBackToList={handleBackToList} />;
      default:
        return <IntroBulk onNext={handleNext} onCancel={handleCancel} />;
    }
  };

  return (
    <div className="mx-auto py-8 px-4 sm:px-6 lg:px-8">
      <BulkProductsHeader
        title={"Add Bulk Product"}
        currentStep={currentStep}
        hasDes={false}
      />

      <div className="mt-8">{renderCurrentStep()}</div>
      <ToastContainer
        position="top-right"
        autoClose={10000}
        hideProgressBar={false}
        newestOnTop={false}
        closeOnClick
        rtl={false}
        pauseOnFocusLoss
        draggable
        pauseOnHover
      />
    </div>
  );
};

export default BulkProducts;
